import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

async function connectApimo(
  payload: ConnectApimoPayload,
  auth: Authentication
): Promise<void> {
  try {
    if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
      throw new ConnectApimoFailure('Unauthorized', 'unauthorized');
    }
    await HttpClient.post('/leedflow/user/connect-apimo', payload.toAPIPayload(), auth.token);
    return;
  } catch (e) {
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new ConnectApimoFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new ConnectApimoFailure(`Erreur lors de la connexion Apimo : ${e.message}`, '400');
    }
  }
}

export class ConnectApimoPayload {
  constructor(
    private userId: string,
    private companyId: string,
    private partnerUid: string
  ) {}

  toAPIPayload(): Record<string, string> {
    return {
      user_id: this.userId,
      company_id: this.companyId,
      partner_uid: this.partnerUid,
    };
  }
}

export class ConnectApimoFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default connectApimo;
